import { Component, OnInit, ViewEncapsulation, Input, Output, ChangeDetectorRef, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { delay, SharedService } from '../../shared';
import { IQuestionnaireSection, IQuestionnaireSubSection, IQuestionnaireQuestion, EnumSectionStatus } from '../questionnaire.model';
import { Options } from '@angular-slider/ngx-slider';
import { UntypedFormControl } from '@angular/forms';


@Component({
    selector: 'pos-neg-slider',
    templateUrl: "./pos-neg-slider.component.html",
    styleUrls: ["./pos-neg-slider.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class PosNegSliderComponent implements OnInit, OnChanges {
    @Input() section: IQuestionnaireSection = null;
    @Input() subSection: IQuestionnaireSubSection = null;
    @Input() question: IQuestionnaireQuestion = null;
    @Input() status: EnumSectionStatus = EnumSectionStatus.ACTIVE;
    @Input() sliderId: string = new Date().getTime().toString();

    @Output() onPosNegSliderChange: EventEmitter<any> = new EventEmitter();

    sliderControl: UntypedFormControl = new UntypedFormControl(0);
    EnumSectionStatus = EnumSectionStatus;


    get sliderOptions(): Options {
        return {
            floor: -5,
            ceil: 5,
            showSelectionBar: false,
            step: 1,
            showTicks: true,
            showTicksValues: true,
            disabled: this.status == EnumSectionStatus.COMPLETED ? true : false
        }
    };

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        this.fnSetSliderValue();
    }

    ngOnChanges(changes: SimpleChanges): void {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                this.fnSetSliderValue();
            }
        }
    }

    fnSetSliderValue() {
        this.sliderControl.setValue(this.question.answer.value);
    }

    onUserChange(event) {
        this.question.hasError = false;
        this.onPosNegSliderChange.emit({ value: event.value });
    }

}
